import { CheckCircle } from 'lucide-react';

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md text-center">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
        <h1 className="page-title mb-2">Thank you!</h1>
        <p className="text-gray-600">
          Your revenue data has been submitted successfully. We appreciate your collaboration.
        </p>
      </div>
    </div>
  );
}
